import moment from "moment";

import * as actionTypes from "./actionTypes";
import * as Utilities from "../../util/Utilities";

const initialState = {
  isPending: false,
  customers: [],
  currentCustomer: null,
  error: null,
  validUntil: null
};

const getUpdatedCustomersIsSuccess = (state, action) => {
  const updated = Utilities.updateStateObject(state, {
    isPending: false,
    customers: action.customers
  });

  if (action.refreshValidity) {
    const d = process.env.REACT_APP_API_CACHE_DURATION;
    updated.validUntil = moment(new Date()).add(JSON.parse(d));
  }
  return updated;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CUSTOMERS_API_IS_PENDING:
      return Utilities.updateStateObject(state, {
        isPending: true,
        error: null
      });

    case actionTypes.GET_CUSTOMERS_IS_SUCCESS:
      return getUpdatedCustomersIsSuccess(state, action);
    case actionTypes.GET_CUSTOMERS_FTSEARCH_IS_SUCCESS:
      return getUpdatedCustomersIsSuccess(state, action);
    case actionTypes.GET_CUSTOMER_IS_SUCCESS:
      return Utilities.updateStateObject(state, {
        isPending: false,
        currentCustomer: action.customer
      });

    case actionTypes.GET_CUSTOMERS_API_IS_ERROR:
      return Utilities.updateStateObject(state, {
        isPending: false,
        error: action.error
      });
    default:
      return state;
  }
};
